import { useCurrency } from '@contexts/CurrencyContext';
import { CURRENCY_COOKIE_NAME } from '@lib/constants/cookies';
import Cookie from 'js-cookie';
import { useSyncExternalStore } from 'react';
import { SUPPORTED_CURRENCIES } from 'utils';
import { subscribeToGuestCart } from './guestCart';

const readCurrencyCookie = (): string | undefined => {
  const value = Cookie.get(CURRENCY_COOKIE_NAME);
  return value && SUPPORTED_CURRENCIES.includes(value) ? value : undefined;
};

/**
 * The currency to price the cart in. A tab that did not render the last
 * footer switch holds the old one in state, and adopting a cart another tab
 * re-priced would re-price it back: the tabs would undo each other for ever.
 * The cookie is the shared record of the switch, re-read when the guest cart
 * changes.
 */
export const useCartCurrency = (): string => {
  const { currency } = useCurrency();
  const cookieCurrency = useSyncExternalStore(
    subscribeToGuestCart,
    readCurrencyCookie,
    () => undefined
  );
  return cookieCurrency ?? currency;
};
